import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CreateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"create"}/>
}
